import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { formattedError, goTop } from '@helpers/functions';
import { AlertService } from '@shared/alert/alert.service';
import { IResourceForm } from '@shared/base-resource-form/base-resource-form';
import { Observable } from 'rxjs';

@Component({
    selector: 'sume-card-buttons',
    templateUrl: './card-buttons.component.html',
})
export class CardButtonsComponent implements OnInit {
    @Input('formGroup') formGroupRefDeprecated: FormGroup;
    @Input() goBackLink = '..';
    @Input() linkQueryParams = {};
    @Input('formGroupRef') formGroupRef: FormGroup;
    @Input('formComponentRef') formComponentRef: IResourceForm;
    @Input('onSubmit') submitFunc: () => Observable<any> | void;
    @Input('onCancel') cancelFunc!: () => void;
    @Input() noRedirect = false;
    @Input() spinnerName: string = null;
    // TODO renomear @Input para customSubmitLabel
    @Input('secondButtonName') customSubmitLabel = 'Salvar';
    // TODO renomear @Input para showSecondaryButton
    @Input('primaryButton') showSecondaryButton = true;
    @Input() markAllAsTouched: () => void;
    @Input() canSubmit: boolean;

    submit_hover = true;
    isRouteRelative!: boolean;

    constructor(
        private router: Router,
        private route: ActivatedRoute,

        private alertService: AlertService
    ) {}
    ngOnInit(): void {
        this.isRouteRelative =
            this.goBackLink.startsWith('..') ||
            this.goBackLink.startsWith('/..');
    }

    onCancel() {
        if (this.cancelFunc) {
            this.cancelFunc();
        } else {
            this.router.navigate([this.goBackLink], {
                queryParams: this.linkQueryParams,
                relativeTo: this.isRouteRelative ? this.route : null,
            });
        }
    }

    onSubmit() {
        if (this.disableSubmit) {
            return;
        }
        if (this.noRedirect) {
            this.submitFunc();
        } else {
            const res = this.submitFunc();
            if (res instanceof Observable)
                res.subscribe(this._defaultSubscribe, err => {
                    this.alertService.error(formattedError(err));
                    window.scrollTo(0, 0);
                });
            else console.log('onSubmit não retornou Observable');
        }
    }

    onMouseOver() {
        if (this.markAllAsTouched) this.markAllAsTouched();
        else if (this.formComponentRef)
            this.formComponentRef.markAllAsTouched();
        else if (this.formGroupRefDeprecated)
            this.formGroupRefDeprecated.markAllAsTouched();
        else if (this.formGroupRef) this.formGroupRef.markAllAsTouched();
    }

    private _defaultSubscribe = res => {
        goTop();
        this.alertService.success(
            res.message || 'Operação realizada com sucesso!',
            true
        );
        this.router.navigate([this.goBackLink], {
            relativeTo: this.isRouteRelative ? this.route : null,
            queryParams: this.linkQueryParams,
        });
    };

    get formGroup(): FormGroup {
        if (this.formGroupRefDeprecated instanceof FormGroup)
            return this.formGroupRefDeprecated;
        else if (this.formGroupRef instanceof FormGroup)
            return this.formGroupRef;
        else return this.formComponentRef.resourceForm;
    }

    get disableSubmit(): boolean {
        if (typeof this.canSubmit === 'boolean') return !this.canSubmit;
        if (this.formComponentRef) return !this.formComponentRef.valid;
        if (this.formGroupRef) return !this.formGroupRef.valid;

        return !this.formGroupRefDeprecated?.valid;
    }
}
